import { useState } from "react";
import type { TextFieldProps } from "@mui/material/TextField";
import { TextInput } from "./TextInput";
import { PasswordVisibilityToggle } from "./PasswordVisibilityToggle";
import type { FieldErrorProps } from "Hooks/useFieldError";

type Props = Omit<
  TextFieldProps & FieldErrorProps,
  "type" | "inputEndAdornment"
> & {
  label?: string;
  maxLength?: number;
  disableHelperText?: boolean;
};

export const PasswordInput = (props: Props) => {
  const [isPlainText, setIsPlainText] = useState(false);

  const handleToggleVisibility = () => {
    setIsPlainText((prev) => !prev);
  };

  return (
    <TextInput
      {...props}
      type={isPlainText ? "text" : "password"}
      inputEndAdornment={
        <PasswordVisibilityToggle
          isPlainText={isPlainText}
          onToggle={handleToggleVisibility}
          disabled={props.disabled}
        />
      }
    />
  );
};
